<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("ExecuteTestRuns_title")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <v-text-field
                      id="Testname-field-search-validationProcess"
                      :label="'Test Name'"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      v-model="searchName"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      id="button-search-rowtable-dataIntegration"
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      prepend-icon="mdi-magnify"
                      @click="Search"
                    >
                      {{ $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              <div v-if="permissions.add" class="action-controls">
                <!-- Refresh Button -->
                <v-btn
                  id="button-refresh-validationprocess"
                  color="grey-darken-1"
                  class="control-btn refresh-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  @click="ReFreshGet()"
                  icon
                >
                  <v-icon size="24">mdi-refresh</v-icon>
                  <v-tooltip activator="parent" location="top">
                    Refresh
                  </v-tooltip>
                </v-btn>

                <!-- Divider -->
                <v-divider
                  vertical
                  thickness="1"
                  length="50"
                  class="mx-4"
                ></v-divider>

                <!-- Add Button -->
                <v-btn
                  id="button-add-validationprocess"
                  color="primary"
                  class="control-btn create-btn"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-plus-circle"
                  rounded="xl"
                  @click="showPopup()"
                >
                  <span class="btn-text">{{ $t("add") }}</span>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          class="modern-table"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :items="dataTable"
          :headers="headers"
          :loading="loadingTable"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: left">{{ item.number }}</td>
              <td style="text-align: left">{{ item.name }}</td>
              <td style="text-align: left">{{ item.result }}</td>
              <td style="text-align: left">{{ item.status }}</td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: left">{{ item.processingDate }}</td>
              <td style="text-align: center">
                <v-btn
                  v-if="permissions.edit"
                  id="button-reprocess-validationprocess"
                  color="orange-lighten-1"
                  variant="flat"
                  size="small"
                  :disabled="
                    item.status === 'Processing' || item.status === 'scoring'
                  "
                  @click="Reprocess(item)"
                  class="minimal-btn"
                  icon
                >
                  <v-icon size="22" color="white">mdi-file-sync</v-icon>
                  <v-tooltip activator="parent" location="top">
                    Reprocess
                  </v-tooltip>
                </v-btn>
              </td>
              <td style="text-align: center">
                <div class="action-container">
                  <div class="action-group">
                    <!-- Edit -->
                    <v-btn
                      v-if="permissions.edit || permissions.view"
                      id="button-edit-popupedit-validationprocess"
                      variant="text"
                      density="comfortable"
                      @click="showPopup(item.processID)"
                      class="action-btn edit-btn"
                      icon
                      :disabled="item.status === 'Processing'"
                    >
                      <v-icon size="18">{{ isViewOnly ? 'mdi-eye-outline' : 'mdi-pencil-outline' }}</v-icon>
                      <v-tooltip activator="parent" location="top">
                        {{ isViewOnly ? 'View' : 'Edit' }}
                      </v-tooltip>
                    </v-btn>

                    <!-- Download -->
                    <v-btn
                      id="button-download-validationprocess"
                      variant="text"
                      density="comfortable"
                      @click="Download(item.processID, item.name, item.isGroup)"
                      class="action-btn download-btn"
                      icon
                      :disabled="item.status === 'Processing'"
                    >
                      <v-icon size="18">mdi-download-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Download Results
                      </v-tooltip>
                    </v-btn>

                    <!-- Custom Divider -->
                    <div v-if="permissions.edit && permissions.delete" class="action-divider"></div>

                    <!-- Delete -->
                    <v-btn
                      v-if="permissions.delete"
                      id="button-delete-validationprocess"
                      variant="text"
                      density="comfortable"
                      @click="DeleteProcessPopup(item.processID)"
                      class="action-btn delete-btn"
                      icon
                      :disabled="item.status === 'Processing'"
                    >
                      <v-icon size="18">mdi-delete-outline</v-icon>
                      <v-tooltip activator="parent" location="top">
                        Delete
                      </v-tooltip>
                    </v-btn>
                  </div>
                </div>
              </td>
              <td style="text-align: center; padding: 8px">
                <v-btn
                  id="button-score-validationprocess"
                  icon
                  variant="flat"
                  size="large"
                  class="score-btn"
                  @click="GoToScore(item.processID, item.isRagas, item.isScore)"
                  :disabled="item.status !== 'success'"
                >
                  <v-icon
                    size="24"
                    :color="item.status === 'success' ? 'white' : 'grey'"
                  >
                    mdi-chart-bar
                  </v-icon>
                  <v-tooltip activator="parent" location="top">
                    {{
                      item.status === "success"
                        ? "View Score Dashboard"
                        : "Complete process to view scores"
                    }}
                  </v-tooltip>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <v-dialog ref="form" v-model="Uploaddialog" persistent max-width="900px" class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header Section -->
        <v-card-title class="dialog-header"
        :class="{'dialog-header-edit': processID, 'dialog-header-add': !processID}">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon color="white" size="32">
                  {{ processID ? "mdi-pencil" : "mdi-upload" }}
                </v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">
                  {{
                    processID
                      ? "Edit Validation Process"
                      : "Upload Question Set"
                  }}
                </h2>
                <p class="dialog-subtitle">
                  {{
                    processID
                      ? "Modify the existing validation configuration"
                      : "Create a new validation test configuration"
                  }}
                </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
                icon
                variant="text"
                @click="closeUploaddialog"
                class="close-button"
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <!-- Content Section -->
        <v-card-text class="dialog-content">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <!-- Test Name -->
              <v-col cols="12" sm="12" md="6">
                <div class="field-container">
                  <v-text-field
                    id="testname-field-validationprocess"
                    label="Test Name*"
                    v-model="Validation.validationName"
                    :rules="[rules.required]"
                    variant="outlined"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    clearable
                    hide-details="auto"
                    required
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" size="small"
                        >mdi-test-tube</v-icon
                      >
                    </template>
                    <template v-slot:append-inner>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            v-bind="props"
                            color="grey-darken-1"
                            size="small"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("_InfoValidationName") }}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </div>
              </v-col>

              <!-- Model Name -->
              <v-col cols="12" sm="12" md="6">
                <div class="field-container">
                  <v-autocomplete
                    id="modelname-autocomplete-validationprocess"
                    label="Model Name"
                    :items="DDGPTModel"
                    item-title="name"
                    item-value="modelDisplayID"
                    variant="outlined"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    clearable
                    hide-details="auto"
                    v-model="Validation.modelId"
                    :rules="[rules.required]"
                    required
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" size="small">mdi-brain</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            v-bind="props"
                            color="grey-darken-1"
                            size="small"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("_InfoModelName") }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>

              <!-- Question Type Radio Group -->
              <v-col cols="12" sm="12" md="8">
                <div class="field-container">
                  <label class="field-label">Question Type</label>
                  <v-radio-group
                    v-model="Validation.positive"
                    @change="clearRadio()"
                    class="modern-radio-group"
                    inline
                  >
                    <div class="radio-container">
                      <v-radio
                        id="positive-radio-validationprocess"
                        label="Positive"
                        :value="true"
                        color="success"
                        :disabled="!QuestionType"
                        class="modern-radio"
                      >
                        <template v-slot:label>
                          <div class="radio-label-wrapper">
                            <v-icon size="small" color="success" class="mr-1"
                              >mdi-thumb-up</v-icon
                            >
                            <span>Positive</span>
                            <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  color="grey-darken-1"
                                  size="small"
                                  class="ml-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Positive validation questions</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-radio>

                      <v-radio
                        id="negative-radio-validationprocess"
                        label="Negative"
                        :value="false"
                        color="error"
                        :disabled="!QuestionType"
                        class="modern-radio"
                      >
                        <template v-slot:label>
                          <div class="radio-label-wrapper">
                            <v-icon size="small" color="error" class="mr-1"
                              >mdi-thumb-down</v-icon
                            >
                            <span>Negative</span>
                            <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  v-bind="props"
                                  color="grey-darken-1"
                                  size="small"
                                  class="ml-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Negative validation questions</span>
                            </v-tooltip>
                          </div>
                        </template>
                      </v-radio>
                    </div>
                  </v-radio-group>
                </div>
              </v-col>

              <!-- Chain Option -->
              <v-col cols="12" sm="12" md="4">
                <div class="field-container">
                  <label class="field-label">Processing Type</label>
                  <v-radio-group
                    v-model="Validation.isGroup"
                    @change="ChainRadio()"
                    :disabled="!QuestionType"
                    class="modern-radio-group"
                  >
                    <v-radio
                      id="chain-radio-validationprocess"
                      label="Chain"
                      :value="true"
                      color="info"
                      class="modern-radio"
                    >
                      <template v-slot:label>
                        <div class="radio-label-wrapper">
                          <v-icon size="small" color="info" class="mr-1"
                            >mdi-link-variant</v-icon
                          >
                          <span>Chain</span>
                          <v-tooltip location="top" max-width="300px">
                            <template v-slot:activator="{ props }">
                              <v-icon
                                v-bind="props"
                                color="grey-darken-1"
                                size="small"
                                class="ml-1"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>Chain processing mode</span>
                          </v-tooltip>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
              </v-col>

              <!-- Question Set Selection -->
              <v-col cols="12" sm="12" md="6">
                <div class="field-container">
                  <!-- Positive Questions -->
                  <v-autocomplete
                    v-if="Validation.positive"
                    id="questionsetname-autocomplete-validationprocess"
                    label="Question Set Name"
                    :items="DDGenerateQ"
                    item-title="name"
                    item-value="generateID"
                    variant="outlined"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    clearable
                    hide-details="auto"
                    v-model="Validation.generateId"
                    :disabled="Validation.entity != null || Validation.isGroup"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="success" size="small"
                        >mdi-help-circle</v-icon
                      >
                    </template>
                    <template v-slot:append-inner>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            v-bind="props"
                            color="grey-darken-1"
                            size="small"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("_InfoQuestionPositiveName") }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>

                  <!-- Chain Questions -->
                  <v-autocomplete
                    v-else-if="Validation.isGroup"
                    id="chainquestion-autocomplete-validationprocess"
                    label="Chain Question"
                    :items="chainQuestionList"
                    item-title="name"
                    item-value="generateID"
                    variant="outlined"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    clearable
                    hide-details="auto"
                    v-model="Validation.generateId"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="info" size="small"
                        >mdi-link-variant</v-icon
                      >
                    </template>
                    <template v-slot:append-inner>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            v-bind="props"
                            color="grey-darken-1"
                            size="small"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Question positive name</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>

                  <!-- Negative Questions -->
                   
                  <!-- id="chainquestion-autocomplete-validationprocess"
                    label="Chain Question"
                    :items="chainQuestionList"
                    item-title="name"
                    item-value="generateID"
                    variant="outlined"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    clearable
                    hide-details="auto"
                    v-model="Validation.generateId" -->

                    <!-- id="questionnegativename-autocomplete-validationprocess"
                    label="Questions negative Name"
                    :items="DDValidationNegative"
                    variant="outlined"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    clearable
                    hide-details="auto"
                    v-model="Validation.negativeName"
                    :disabled="Validation.entity != null || Validation.isGroup" -->
                  <v-autocomplete
                    v-else
                    id="questionnegativename-autocomplete-validationprocess"
                    label="Questions negative Name"
                    :items="DDValidationNegative"
                    variant="outlined"
                    density="comfortable"
                    color="primary"
                    class="modern-field"
                    clearable
                    hide-details="auto"
                    v-model="Validation.negativeName"
                    :disabled="Validation.entity != null || Validation.isGroup"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="error" size="small"
                        >mdi-help-circle</v-icon
                      >
                    </template>
                    <template v-slot:append-inner>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            v-bind="props"
                            color="grey-darken-1"
                            size="small"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t("_InfoQuestionNegativeName") }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </div>
              </v-col>

              <!-- File Upload -->
              <v-col cols="12" sm="12" md="3" style="margin-top: -20px">
                <div class="field-container">
                  <label class="field-label">Upload File</label>
                  <DragDropFile
                    :dialog="true"
                    :DragDrop="false"
                    :ShowListFile="false"
                    :DisabledBtn="
                      Validation.generateId != null ||
                      Validation.negativeName != null
                    "
                    :allowType="[
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    ]"
                    @filesUploaded="processUpload($event)"
                    class="UploadFile"
                  />
                </div>
              </v-col>

              <!-- Template Download -->
              <v-col
                cols="12"
                sm="12"
                md="3"
                style="display: flex; margin-top: -15px"
              >
                <div class="field-container" style="width: 100%">
                  <label class="field-label" style="opacity: 0">Template</label>
                  <v-btn
                    v-if="Validation.isGroup"
                    id="downloadtemplate-validationprocess"
                    variant="outlined"
                    color="info"
                    size="small"
                    prepend-icon="mdi-download"
                    @click="chainTemplate()"
                    class="template-download-btn"
                    block
                  >
                    {{ $t("Template") }}
                  </v-btn>
                </div>
              </v-col>

              <!-- Uploaded Files Display -->
              <v-col
                cols="12"
                sm="12"
                md="12"
                v-show="Validation.entity != null"
              >
                <div class="field-container">
                  <v-card
                    v-if="uploadedFiles.length > 0"
                    class="files-card"
                    elevation="2"
                    rounded="lg"
                  >
                    <v-virtual-scroll
                      :items="uploadedFiles"
                      :height="Math.min(uploadedFiles.length * 60, 120)"
                      :item-height="60"
                    >
                      <template v-slot:default="{ item }">
                        <v-list-item class="file-item px-4 py-2">
                          <template v-slot:prepend>
                            <v-avatar size="36" color="success" class="mr-3">
                              <v-icon color="white" size="18"
                                >mdi-file-document</v-icon
                              >
                            </v-avatar>
                          </template>

                          <v-list-item-title
                            class="text-subtitle-2 font-weight-medium"
                          >
                            {{ item.name }}
                          </v-list-item-title>

                          <v-list-item-subtitle class="text-caption">
                            {{ item.size }} bytes
                          </v-list-item-subtitle>

                          <template v-slot:append>
                            <v-btn
                              @click.stop="removeFile(item.name)"
                              icon="mdi-close"
                              size="small"
                              variant="text"
                              color="error"
                              class="ml-2"
                            />
                          </template>
                        </v-list-item>
                        <v-divider
                          class="mx-4"
                          v-if="
                            uploadedFiles.indexOf(item) <
                            uploadedFiles.length - 1
                          "
                        />
                      </template>
                    </v-virtual-scroll>
                  </v-card>
                </div>
              </v-col>

              <!-- Calculate Scores Checkbox -->
              <v-col cols="12" sm="6" md="6">
                <div class="field-container">
                  <v-checkbox
                    id="calculatescores-checkbox-validationprocess"
                    v-model="Validation.isScore"
                    color="primary"
                    hide-details
                    class="modern-checkbox"
                    @change="handleScoreChange"
                  >
                    <template v-slot:label>
                      <div class="checkbox-label-wrapper">
                        <v-icon size="small" color="primary" class="mr-2"
                          >mdi-calculator</v-icon
                        >
                        <span>{{ $t("calculateScores") }}</span>
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <v-icon
                              v-bind="props"
                              color="grey-darken-1"
                              size="small"
                              class="ml-1"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("calculateScores") }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </v-col>

              <!-- RAGAS Evaluation Checkbox -->
              <v-col cols="12" sm="6" md="6">
                <div class="field-container">
                  <v-checkbox
                    id="ragas-checkbox-validationprocess"
                    v-model="Validation.isRagas"
                    color="purple"
                    hide-details
                    class="modern-checkbox"
                    @change="handleRagasChange"
                  >
                    <template v-slot:label>
                      <div class="checkbox-label-wrapper">
                        <v-icon size="small" color="purple" class="mr-2"
                          >mdi-chart-box-outline</v-icon
                        >
                        <span>Calculate Scores with RAGAS</span>
                        <v-tooltip location="top" max-width="300px">
                          <template v-slot:activator="{ props }">
                            <v-icon
                              v-bind="props"
                              color="grey-darken-1"
                              size="small"
                              class="ml-1"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>Evaluate with 4 RAGAS metrics: Faithfulness, Answer Relevancy, Context Precision, Context Recall</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </v-col>

              <!-- Prompt Textarea -->
              <v-col cols="12" sm="12" md="12" v-show="Validation.isScore">
                <div class="field-container">
                  <v-textarea
                    label="Prompt"
                    variant="outlined"
                    rows="8"
                    auto-grow
                    counter
                    color="primary"
                    class="modern-textarea"
                    v-model="Validation.Prompt"
                    hide-details="auto"
                    required
                    :placeholder="promptPlaceholder"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" size="small"
                        >mdi-text-long</v-icon
                      >
                    </template>
                  </v-textarea>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <!-- Actions Section -->
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            color="grey"
            size="large"
            @click="closeUploaddialog"
            class="cancel-btn"
            prepend-icon="mdi-close"
          >
            {{ $t("close") }}
          </v-btn>
          <v-btn
            v-if="processID ? permissions.edit : permissions.add"
            id="button-save-popup-validationprocess"
            variant="flat"
            size="large"
            @click="Save"
            class="dialog-action-btn"
            :class="{
              'save-btn-edit': processID,
              'save-btn-add': !processID,
            }"
            :prepend-icon="
              ProcessID ? 'mdi-content-save-edit' : 'mdi-content-save'
            "
          >
            {{ ProcessID ? $t("edit") : $t("save")  }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import DragDropFile from "@/components/DragDropFile.vue";
import Cookies from "js-cookie";
import ExcelJS from "exceljs";
export default {
  name: "ValidationProcess",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: { DragDropFile },
  data: () => ({
    userId: Cookies.get("userId"),
    searchName: "",
    ProcessID: null,
    valid: true,
    checkbox1: false,
    dialog: false,
    Uploaddialog: false,
    today: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    isFirst: true,
    loadingTable: true,
    DeleteProcessPopUp: false,
    QuestionType: null,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    DDGPTModel: [],
    DDGenerateQ: [],
    chainQuestionList: [],
    DDValidationNegative: [],
    DDValidationPositive: [],
    uploadedFiles: [],
    DDProvider: [
      "Azure",
      "Azure Postgresql",
      // "Azure Internet",
      // "Azure News",
    ],
    Validation: {
      validationName: null,
      modelId: null,
      positive: true,
      negative: false,
      positiveUploadFlag: true,
      generateId: null,
      positiveName: null,
      negativeName: null,
      isScore: false, //true
      isGroup: false,
      isRagas: false,
      entity: null,
      Prompt: null,
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    sortBy: [],
    sortDesc: [],
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ValidationProcess');
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('ValidationProcess'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('ValidationProcess'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('ValidationProcess'),
        view: this.isViewOnly,
      }
    },
    promptPlaceholder() {
      return 'e.g.\nคุณเป็นผู้ตรวจสอบคุณภาพคำตอบของ AI\nตอบเป็น JSON เท่านั้น: {"score": 0-2, "reason": "เหตุผล"}';
    },
    headers() {
      return [
        { title: this.$t("no"), align: "left", sortable: false },
        { title: "Test Name", align: "left", sortable: true, value: "Name" },
        {
          title: "Process",
          align: "left",
          sortable: true,
          value: "ImportedDataCount",
        },
        { title: "Status", align: "left", sortable: true, value: "Status" },
        {
          title: "Create by",
          align: "left",
          sortable: true,
          value: "CreateBy",
        },
        {
          title: "Data Processed",
          align: "left",
          sortable: true,
          value: "ProcessingDate",
        },
        { title: "Reprocess", align: "center", sortable: false },
        { title: "Action", align: "center", sortable: false },
        { title: "Result", align: "left", sortable: false },
      ];
    },
  },
  watch: {
    "Validation.isGroup"(newVal) {
      if (newVal === true) {
        this.Validation.positive = null;
      }
    },
    // 'Validation.positive'(newVal){
    //   if (newVal === true){
    //     this.Validation.negative = !newVal
    //   }
    // },
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    validate() {
      this.$refs.form.validate();
    },
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.Get();
    },
    closeUploaddialog() {
      let self = this;
      self.ProcessID = null;
      self.Uploaddialog = false;
      self.uploadedFiles = [];
      self.DeleteProcessPopUp = false;
      self.Validation.entity = null;
      self.Validation.validationName = null;
      self.Validation.modelId = null;
      self.Validation.positive = true;
      self.Validation.positiveFlag = null;
      self.Validation.generateId = null;
      self.Validation.PositiveName = null;
      self.Validation.negativeName = null;
      self.Validation.PositiveUploadFlag = null;
      self.Validation.isScore = false; //true
      self.Validation.isRagas = false;
      self.Validation.isGroup = false;
    },
    clearRadio() {
      this.Validation.generateId = null;
      this.Validation.negativeName = null;
      this.Validation.isGroup = false;
      // Keep isRagas as is - it's now an independent checkbox
    },
    ChainRadio() {
      this.Validation.positive = null;
      this.Validation.generateId = null;
      this.Validation.negativeName = null;
    },
    handleRagasChange() {
      // Both checkboxes can be active simultaneously
    },
    handleScoreChange() {
      // Both checkboxes can be active simultaneously
    },
    Get() {
      let self = this;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      let temp = {
        name: self.searchName,
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableValidationProcess(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
            if (self.sortDesc == null) {
              self.AutoRefresh();
            }
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDetail(id) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      self.$call.GetValidationProcessDetail(
        id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            // self.Edit(dataResponse.data);
            let item = dataResponse.data;
            self.Validation.validationName = item.name;
            self.Validation.modelId = item.modelID == -1 ? null : item.modelID;
            self.Validation.isGroup = item.isGroup;
            self.Validation.positive = item.positiveFlag;
            self.Validation.positiveUploadFlag = item.positiveUploadFlag;
            self.Validation.negativeFlag = item.negativeFlag;
            self.Validation.generateId = item.generateID ?? item.positiveName;
            self.Validation.isScore = item.isScore;
            self.Validation.isRagas = item.isRagas || false;
            self.Validation.positiveName = item.positiveName;
            self.Validation.negativeName = item.negativeName;
            self.Validation.Prompt = item.prompt;
            self.dialog = false;
            self.Uploaddialog = true;
            self.loading = false;
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    ReFreshGet() {
      let self = this;
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      let temp = {
        name: self.searchName,
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableValidationProcess(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      let self = this;
      // self.dialog = true;
      self.loadingTable = true;
      self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          self.GetValidationGenerateDD();
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    GetValidationGenerateDD() {
      let self = this;
      self.loadingTable = true;
      self.$call.GetValidationGenerateDD(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGenerateQ = dataResponse.data;
          } else {
            self.DDGenerateQ = [];
          }
          self.GetValidationPositiveDD();
          self.GetValidationNegativeDD();
          self.loadingTable = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    GetValidationNegativeDD() {
      let self = this;
      self.dialog = true;
      self.$call.GetValidationNegativeDD(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDValidationNegative = dataResponse.data;
          } else {
            self.DDValidationNegative = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetValidationPositiveDD() {
      let self = this;
      self.dialog = true;
      self.$call.GetValidationPositiveDD(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDValidationPositive = dataResponse.data;
            self.DDGenerateQ = self.DDGenerateQ.concat(
              dataResponse.data.map(item => ({
                ...item,
                generateID: item.name
              }))
            ).filter(
              (element) =>
                element.questionType == "P" || element.questionType == null
            );
            self.chainQuestionList = self.DDValidationPositive.filter(
              (element, index, selfArray) =>
                element.questionType == "C" &&
                index ===
                  selfArray.findIndex(
                    (e) => e.name.trim() === element.name.trim()
                  )
            ).map(item => ({ ...item, generateID: item.name }));
          } else {
            self.DDValidationPositive = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      let self = this;

      if (self.processID == null) {
        self.SaveAdd();
      } else {
        self.SaveEdit(self.processID);
      }
    },
    SaveAdd() {
      let self = this;

      setTimeout(() => {
        self.validate();
      }, 100);
      if (
        self.Validation.validationName == null ||
        self.Validation.validationName == "" ||
        self.Validation.modelId == null ||
        self.Validation.modelId == "" ||
        (self.Validation.entity == null &&
          self.Validation.generateId == null &&
          self.Validation.negativeName == null &&
          self.Validation) ||
        (self.Validation.isScore == true &&
          (self.Validation.Prompt == null ||
            self.Validation.Prompt == "" ||
            self.Validation.Prompt == undefined))
        // || self.Validation.entity == null
      ) {
        // use self.$swal.fire to show an alert
        self.$swal.fire({
          icon: "warning",
          title: "Please Fill All The Fields!",
          showConfirmButton: true,
        });
        return;
      }
      self.dialog = true;
      let request = {
        Name: self.Validation.validationName,
        ModelID: self.Validation.modelId,
        PositiveFlag:
          self.Validation.isGroup == true &&
          self.Validation.PositiveName == null
            ? false
            : self.Validation.positive,
        NegativeFlag:
          self.Validation.isGroup == true ? false : !self.Validation.positive,
        PositiveUploadFlag:
          self.Validation.isGroup == true ? false : self.Validation.positive,
        GenerateID:
          typeof self.Validation.generateId === "number"
            ? self.Validation.generateId
            : null,
        PositiveName:
          typeof self.Validation.generateId === "string"
            ? self.Validation.generateId
            : null,
        NegativeName: self.Validation.negativeName,
        IsScore: self.Validation.isScore,
        IsGroup: self.Validation.isGroup,
        Prompt: self.Validation.Prompt,
        IsRagas: self.Validation.isRagas,
      };
      try {
        self.$call.CreateValidationProcess(
          request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data != 0) {
                self.Processing(dataResponse.data);
              } else {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
              self.totalTable = self.totalTable + 1;
              self.Get();
              self.closeUploaddialog();
            }else if (dataResponse.status == 3) {
              self.$swal.fire({
                icon: "warning",
                title: dataResponse.message,
                showConfirmButton: true,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    SaveEdit(id) {
      let self = this;
      setTimeout(() => {
        self.validate();
      }, 100);
      if (
        self.Validation.validationName == null ||
        self.Validation.validationName == "" ||
        self.Validation.modelId == null ||
        self.Validation.modelId == "" ||
        (self.Validation.entity == null &&
          self.Validation.generateId == null &&
          self.Validation.negativeName == null &&
          self.Validation)
        // || self.Validation.entity == null
      ) {
        alert("Please Fill All The Fields!");
        return;
      }
      self.dialog = true;
      let request = {
        ProcessID: id,
        Name: self.Validation.validationName,
        ModelID: self.Validation.modelId,
        PositiveFlag:
          self.Validation.isGroup == true ? false : self.Validation.positive,
        NegativeFlag:
          self.Validation.isGroup == true ? false : !self.Validation.positive,
        PositiveUploadFlag:
          self.Validation.isGroup == true ? false : self.Validation.positive,
        GenerateID:
          typeof self.Validation.generateId === "number"
            ? self.Validation.generateId
            : null,
        PositiveName:
          typeof self.Validation.generateId === "string"
            ? self.Validation.generateId
            : null,
        NegativeName: self.Validation.negativeName,
        IsGroup: self.Validation.isGroup,
        IsScore: self.Validation.isScore,
        Prompt: self.Validation.Prompt,
        IsRagas: self.Validation.isRagas,
      };
      try {
        self.$call.EditValidationProcess(
          request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data != 0) {
                self.Processing(dataResponse.data);
              } else {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
              self.Get();
              self.closeUploaddialog();
            }else if (dataResponse.status == 3) {
              self.$swal.fire({
                icon: "warning",
                title: dataResponse.message,
                showConfirmButton: true,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    GoToScore(id, isRagas, isScore) {
      let self = this;
      self.$router.push({
        name: "DashboardScore",
        query: {
          id: id,
          isRagas: isRagas ? 'true' : 'false',
          isScore: isScore ? 'true' : 'false',
        },
      });
    },
    Processing(id) {
      let self = this;
      self.dialog = true;

      let request = {
        id: id,
        entity: self.Validation.entity,
      };

      try {
        self.$call.UploadValidationProcess(
          request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.closeUploaddialog();
              self.Get();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    resourceResult(result) {
      if (result != "") {
        let arr = result.split("/");
        if (arr.length == 2) {
          return "0/" + arr[1];
        }
      }
      return result;
    },

    Reprocess(source) {
      let self = this;
      self.$swal
        .fire({
          icon: "warning",
          title: this.$t("vectorReprocess"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            if (source.status != "error:score") {
              self.$call.ReprocessValidationProcess(
                source.processID,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    source.status = "Reprocess";
                    source.result = self.resourceResult(source.result);
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.AutoRefresh();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            } else self.ProcessingScore(source);
          }
        });
    },
    ProcessingScore(source) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      let temp = {
        ProcessID: source.processID,
        UserID: self.userId,
      };
      self.$call.ReGenerateValidationScore(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: "success",
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.Adddialog = false;
          console.error(errorResource);
        }
      );
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(
        (file) => file.name === fileName
      );
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit("filesUploaded", this.uploadedFiles);
      this.Validation.entity =
        this.uploadedFiles.length == 0 ? null : this.Validation.entity;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.Validation.entity = null;
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
      };
    },
    ValidateCSVVector(csv, files) {
      // let temp = csv.replaceAll("\r", "");
      // let lines = temp.split("\n");
      // if (lines[0] != "Questions" && !this.Validation.isGroup) {
      //   this.Validation.entity = null;
      //   this.uploadedFiles = [];
      //   alert("Please Enter Correct Format!");
      // } else {
      //   const formDataDoc = new FormData();
      //   formDataDoc.append("entity", files[0]);
      //   this.uploadedFiles = files;
      //   this.Validation.entity = formDataDoc;
      // }

      const formFile = new FormData();
      formFile.append("formFile", files[0]); // key = "formFile" ตรงกับ parameter
      this.dialog = true;
      this.$call.ValidateCSV(
        formFile,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if (dataResponse.data) {
              this.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });

              const formDataDoc = new FormData();
              formDataDoc.append("entity", files[0]);
              this.uploadedFiles = files;
              this.Validation.entity = formDataDoc;
            } else {
              this.$swal.fire({
                  icon: "warning",
                  title: "Please Enter Correct Format!",
                  showConfirmButton: true,
                  backdrop: false
              });
              this.Validation.entity = null;
              this.uploadedFiles = [];
            }
          } else {
            this.$swal.fire({
              icon: "error",
              title: dataResponse.message,
              showConfirmButton: true,
            });
          }
          this.dialog = false;
        },
        (errorResource) => { 
          console.error(errorResource); 
        }
      );
    },
    async downloadtemp() {
      const data = [
        {
          Questions: "จังหวัดที่อยู่เหนือสุดของประเทศไทย",
        },
        {
          Questions: "จังหวัดที่อยู่ใต้สุดของประเทศไทย",
        },
        {
          Questions: "จังหวัดที่มีพื้นที่มากที่สุดของประเทศไทย",
        },
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 30 },
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "upload_questions.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
    Download(id, fileName, isGroup) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      self.$call.DownloadCSVAnswer(
        { id, isGroup: isGroup ?? false },
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileName += isGroup ? ".txt" : ".csv";
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.dialog = false;
          self.loading = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    async chainTemplate() {
      const data = [
        ["Questions"],
        ["สวัสดีครับ"],
        ["Reset password ยังไง"],
        ["ระบบ AMACS"],
        ["#End#"],
        ["สวัสดีครับ"],
        ["ขอ NetworkID"],
        ["ระบบ UMS"],
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 50 },
        { header: "Human Answer", key: "Human Answer", width: 70 },
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFE0E0E0" },
      };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Chain_template.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;

      do {
        for (let value of self.dataTable) {
          let totalSp = value.result.split("/");
          let total = parseInt(totalSp[0]);
          let total2 = parseInt(totalSp[1]);
          if (
            (total < total2 || value.status == "scoring") &&
            (value.status == "Reprocess" ||
              value.status == "Processing" ||
              value.status == "Processing score" ||
              value.status == "scoring")
          ) {
            self.ReFreshGet();
            death_waiting = true;
            break;
          } else {
            death_waiting = false;
          }
        }
        if (window.location.pathname != "/ValidationProcess") {
          death_waiting = false;
        }
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    showPopup(id) {
      let self = this;
      self.processID = null;
      if (id != null) {
        self.processID = id;
        self.QuestionType = false;
        self.GetDetail(id);
      } else {
        self.QuestionType = true;
        self.Uploaddialog = true;
        self.Validation.validationName = null;
        self.Validation.modelId = null;
        // Old prompt (score only, no explanation):
        // self.Validation.Prompt = `You are an evaluator that scores the relevance of a chatbot's response based on the provided input.
        //
        // If only the "Question" and "Bot's Response" are given, evaluate based solely on these two.
        // If a "Human's Response" is also provided, use it as an additional reference for scoring.
        // Scoring criteria:
        //
        // 0: Not related at all
        // 1: Somewhat related
        // 2: Very related
        // Evaluate the following input and respond only with a single number (0, 1, or 2). Do not include any explanation or additional text.
        //
        // Provided data:
        //
        // Question: {Question}
        // Bot's Response: {Bot's Response}
        // Human's Response (if available): {Human's Response}
        // Your response must be only a single number (0, 1, or 2).`;
        self.Validation.Prompt = `IMPORTANT: You are strictly an evaluator. Do NOT answer or respond to the question. Your ONLY task is to score how relevant the Bot's Response is to the Question.

Scoring criteria:
0 = Not related at all — The bot's response has nothing to do with the question
1 = Somewhat related — The bot's response partially addresses the question
2 = Very related — The bot's response directly and accurately addresses the question

If a Human's Response is provided, use it as a reference to compare with the Bot's Response.

The data to evaluate will be provided in the next message in this format:
Question: ...
Bot's Response: ...
Human's Response (if available): ...

Respond with valid JSON only — no extra text:
{"score": 0, "reason": "Brief explanation of why you gave this score"}`;
      }
    },
    //   async DeleteProcessPopup(id) {
    //     try {
    //       const result = await this.$swal.fire({
    //         title: this.$t('confirmDeletion'),
    //         text: "Do you want to confirm deletion of this validation",
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085d6',
    //         cancelButtonColor: '#d33',
    //         confirmButtonText: this.$t('confirm'),
    //         cancelButtonText: this.$t('cancel'),
    //         reverseButtons: false,
    //       });

    //       if (result.isConfirmed) {
    //         this.dialog = true;
    //         this.$call.DeleteValidationProcess(
    //           id,
    //           (dataResponse) => {
    //             this.dialog = false; // Ensure this.dialog is set to false after the operation
    //             if (dataResponse.status === 0) {
    //               this.Get(); // Refresh the data if the deletion was successful
    //               this.$swal.fire({
    //                 icon: 'success',
    //                 title: dataResponse.message,
    //                 showConfirmButton: false,
    //                 timer: 1500,
    //               });
    //             } else if (dataResponse.status === 4) {
    //               this.$swal.fire({
    //                 icon: 'warning',
    //                 title: this.$t('oneSuperAdmin'),
    //                 showConfirmButton: false,
    //                 timer: 2000,
    //               });
    //             } else {
    //               // Handle unexpected statuses
    //               this.$swal.fire({
    //                 icon: 'error',
    //                 title: 'Error',
    //                 text: dataResponse.message || 'An unexpected error occurred',
    //                 showConfirmButton: true,
    //               });
    //             }
    //           },
    //           (errorResource) => {
    //             this.dialog = false;
    //             console.error(errorResource);
    //             this.$swal.fire({
    //               icon: 'error',
    //               title: 'Error',
    //               text: 'An error occurred while processing your request.',
    //               showConfirmButton: true,
    //             });
    //           }
    //         );
    //       }
    //     } catch (error) {
    //       this.LogTrace(error, 'DeleteUser');
    //       this.$swal.fire({
    //         icon: 'error',
    //         title: 'Error',
    //         text: 'An unexpected error occurred.',
    //         showConfirmButton: true,
    //       });
    //     }
    // }
    DeleteProcessPopup(Id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: "Do you want to confirm deletion of this validation",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteValidationProcess(
                Id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                  self.dialog = false;
                  self.Get();
                },
                (errorResource) => {
                  self.dialog = false;
                  self.isSearch = false;
                  self.$swal.fire({
                    title: self.$t("Error"),
                    text: "Something went wrong",
                    icon: "warning",
                  });
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        self.LogTrace(error, "DeleteGroup");
      }
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    self.GetDDGPTModel();
  },
};
</script>
<style scoped>
textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
}
.modern-dialog {
  margin: 24px;
  animation: dialogSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2) !important;
}

/* Dialog Header */
/* .dialog-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  padding: 24px !important;
  position: relative;
  border-bottom: none !important;
}

.header-icon-container {
  background: rgba(25, 118, 210, 0.1);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.header-text {
  flex: 1;
}
*/
/* .dialog-title {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
}

.dialog-subtitle {
  font-size: 0.875rem !important;
  color: #6c757d !important;
  margin: 0 !important;
  font-weight: 400 !important;
} */
/*
.close-btn {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  background: rgba(255, 255, 255, 0.8) !important;
  border-radius: 50% !important;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  transform: scale(1.1) !important;
} */

/* Dialog Content */
.dialog-content {
  padding: 32px 24px !important;
  background: #ffffff;
  max-height: 70vh;
  overflow-y: auto;
}

.field-container {
  margin-bottom: 0px;
}

.field-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
  display: block;
  letter-spacing: 0.25px;
}

/* Modern field and textarea shared styles */
.modern-field :deep(.v-field__outline),
.modern-textarea :deep(.v-field__outline) {
  border-radius: 12px !important;
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-field :deep(.v-field--focused .v-field__outline),
.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-field :deep(.v-field),
.modern-textarea :deep(.v-field) {
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-field:hover :deep(.v-field__outline),
.modern-textarea:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-field :deep(.v-label),
.modern-textarea :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-field :deep(.v-field--focused .v-label),
.modern-textarea :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-field :deep(.v-field__input),
.modern-textarea :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-field :deep(.v-field__input::placeholder),
.modern-textarea :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

.modern-field :deep(.v-field__prepend-inner),
.modern-textarea :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-field :deep(.v-field__append-inner),
.modern-textarea :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}

/* Radio Group Styles */
.modern-radio-group {
  margin-top: 8px !important;
}

.radio-container {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.modern-radio :deep(.v-selection-control) {
  background: rgba(248, 249, 250, 0.8);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 4px 0;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.modern-radio :deep(.v-selection-control:hover) {
  background: rgba(248, 249, 250, 1);
  border-color: rgba(25, 118, 210, 0.2);
}

.modern-radio :deep(.v-selection-control--dirty) {
  border-color: currentColor;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.radio-label-wrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

/* Checkbox Styles */
.modern-checkbox :deep(.v-selection-control) {
  background: rgba(248, 249, 250, 0.8);
  border-radius: 12px;
  padding: 12px 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.modern-checkbox :deep(.v-selection-control:hover) {
  background: rgba(248, 249, 250, 1);
  border-color: rgba(25, 118, 210, 0.2);
}

.modern-checkbox :deep(.v-selection-control--dirty) {
  border-color: rgba(25, 118, 210, 0.3);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.checkbox-label-wrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

/* Files Display */
.files-card {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.12);
  transition: all 0.2s ease;
}

.files-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.3);
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08);
}

.files-card .v-card-title {
  background: rgba(var(--v-theme-surface-variant), 0.3);
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.file-item {
  transition: background-color 0.2s ease;
}

.file-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

.file-item .v-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
}

/* Template Download Button */
.template-download-btn {
  border-radius: 10px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
}

.template-download-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.3) !important;
}

/* Dialog Actions */
.dialog-actions {
  background: rgba(248, 249, 250, 0.5) !important;
  padding: 20px 24px !important;
  gap: 12px;
}

.cancel-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  border-color: #dee2e6 !important;
  color: #6c757d !important;
}

.cancel-btn:hover {
  background: #f8f9fa !important;
  border-color: #adb5bd !important;
  color: #495057 !important;
}

.save-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
}

.save-edit-btn {
  border-radius: 10px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 12px rgba(255, 164, 7, 0.3) !important;
  transition: all 0.3s ease !important;
}

.save-edit-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(255, 164, 7, 0.4) !important;
}

/* Upload File Component Integration */
.UploadFile {
  width: 100%;
}
.score-btn {
  border-radius: 50% !important;
  width: 48px !important;
  height: 48px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  background: linear-gradient(135deg, #9c27b0 0%, #673ab7 100%) !important;
  box-shadow: 0 4px 12px rgba(156, 39, 176, 0.3) !important;
}

.score-btn:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.05) !important;
  box-shadow: 0 8px 20px rgba(156, 39, 176, 0.4) !important;
  background: linear-gradient(135deg, #ab47bc 0%, #7e57c2 100%) !important;
}

.score-btn:active:not(:disabled) {
  transform: translateY(0) scale(1) !important;
}

.score-btn:disabled {
  background: #e0e0e0 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  cursor: not-allowed !important;
  transform: none !important;
  opacity: 0.6 !important;
}

.score-btn .v-icon {
  transition: transform 0.2s ease !important;
}

.score-btn:hover:not(:disabled) .v-icon {
  transform: scale(1.1) rotate(5deg) !important;
}

/* Pulse animation for active state */
.score-btn:not(:disabled) {
  position: relative;
}

.score-btn:not(:disabled)::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: rgba(156, 39, 176, 0.3);
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.3s ease;
}

.score-btn:hover:not(:disabled)::before {
  transform: translate(-50%, -50%) scale(1.3);
  opacity: 0;
}

/* Shimmer effect for successful state */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.score-btn:not(:disabled) {
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
}

/* Enhanced tooltip styling */
.score-btn .v-tooltip {
  font-size: 0.875rem !important;
  font-weight: 500 !important;
}

/* =============================================================================
   RESPONSIVE DESIGN FOR SCORE BUTTON
   ============================================================================= */
@media (max-width: 768px) {
  .score-btn {
    width: 40px !important;
    height: 40px !important;
  }

  .score-btn .v-icon {
    font-size: 20px !important;
  }
}

/* =============================================================================
   ACTION BUTTONS GROUP ENHANCEMENT
   ============================================================================= */
.action-buttons-group {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.action-btn {
  border-radius: 8px !important;
  transition: all 0.2s ease !important;
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
}

.action-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.edit-btn:hover {
  background-color: rgba(var(--v-theme-primary), 0.1) !important;
}

.reprocess-btn:hover {
  background-color: rgba(var(--v-theme-info), 0.1) !important;
}

.download-btn:hover:not(:disabled) {
  background-color: rgba(var(--v-theme-success), 0.1) !important;
}

.download-btn:disabled {
  background-color: rgba(0, 160, 35, 0.295) !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}

.delete-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
}

/* Rotating animation for reprocess icon */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotate 1s linear infinite;
}

/* Hover effects for icons */
.action-btn .v-icon {
  transition: transform 0.2s ease !important;
}

.action-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* Disabled state styling */
.action-btn:disabled {
  cursor: not-allowed !important;
}

.action-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
}

/* Action divider */
.action-divider {
  width: 1px;
  height: 24px;
  background: rgba(0, 0, 0, 0.12);
  margin: 0 4px;
}

:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
  width: 100% !important;
  border-radius: 10px !important;
  font-weight: 500 !important;
}

/* Animations */
@keyframes dialogSlideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .dialog-header {
    padding: 20px 16px !important;
  }

  .header-icon-container {
    width: 48px;
    height: 48px;
    margin-right: 12px;
  }

  .dialog-title {
    font-size: 1.25rem !important;
  }

  .dialog-content {
    padding: 24px 16px !important;
  }

  .dialog-actions {
    padding: 16px !important;
    flex-direction: column;
  }

  .cancel-btn,
  .save-btn,
  .save-edit-btn {
    width: 100% !important;
    min-width: auto !important;
  }

  .radio-container {
    flex-direction: column;
    gap: 8px;
  }
}
.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 200px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}


/* action disable button delete */
.delete-btn:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  background-color: rgba(236, 15, 15, 0.304) !important;
  pointer-events: none !important;
}

.delete-btn:disabled .v-icon {
  color: rgb(253, 19, 3) !important;
}

.delete-btn:disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  background-color: rgba(244, 67, 54, 0.1) !important;
}

.edit-btn:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  background-color: rgba(245, 193, 37, 0.686) !important;
  pointer-events: none !important;
}

.edit-btn:disabled .v-icon {
  color: rgb(155, 122, 31) !important;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}

</style>
